import React from 'react';
import { Question } from 'types/questionnaire/types';
import YesNoQuestion from './YesNoQuestion';
import ConfirmationCheckboxQuestion from './ConfirmationCheckboxQuestion';
import AgreeQuestion from './AgreeQuestion';
import ChoiceQuestion from './ChoiceQuestion';

export interface QuestionRendererProps {
  question: Question;
  value: unknown;
  onChange: (value: unknown) => void;
  onAdvance: () => void;
  error?: string;
  stopWarning?: boolean;
  isSubmitting?: boolean;
}

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  value,
  onChange,
  onAdvance,
  error,
  stopWarning,
  isSubmitting,
}) => {
  switch (question.type) {
    case 'yes_no':
      return (
        <YesNoQuestion
          question={question}
          value={value as boolean | null | undefined}
          onChange={(v) => onChange(v)}
          error={error}
          stopWarning={stopWarning}
        />
      );
    case 'checkbox':
      return (
        <ConfirmationCheckboxQuestion
          question={question}
          value={value as boolean | undefined}
          onChange={(v) => onChange(v)}
          onAdvance={onAdvance}
          error={error}
        />
      );
    case 'agree':
      return (
        <AgreeQuestion
          question={question}
          value={value as boolean | undefined}
          onChange={(v) => onChange(v)}
          error={error}
          stopWarning={stopWarning}
          loading={isSubmitting}
        />
      );
    case 'choice':
      return (
        <ChoiceQuestion
          question={question}
          value={value as string | null | undefined}
          onChange={(v) => onChange(v)}
          error={error}
        />
      );
    default:
      return <div>Unsupported question type: {question.type}</div>;
  }
};

export default QuestionRenderer;
